import React, { FC } from "react";
import { Element } from "../../../../models/elementModel";
import { TabelCell } from "../../../../models/tabelCellModel";
import { TableRowModel } from "../../../../models/tableRowModel";
import CellItemProperties from "./cellItemProperties";

export interface CellListPropertiesProps {
    element: Element;
    row : TableRowModel;
    rowIndex: number;
  }

const CellListProperties: FC<CellListPropertiesProps> = ({element, row, rowIndex}) => {
  return (
    <div className="card border-0">
      <div className="" id={`tableCells-${rowIndex}`}>
        <h5 className="mb-0">
          <button
            className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
            data-toggle="collapse"
            data-target={`#Table-cell-content-${rowIndex}`}
            aria-expanded="false"
            aria-controls={`Table-cell-content-${rowIndex}`}
          >
            Cells
          </button>
        </h5>
      </div>
      <div
        id={`Table-cell-content-${rowIndex}`}
        className="collapse"
        aria-labelledby={`tableCells-${rowIndex}`}
      >
        <div className="card-body theam-card">
          {row.cells.map((cell: TabelCell, i: number) => {
            return (
              <CellItemProperties
                element={element}
                cell={cell}
                rowIndex={rowIndex}
                cellIndex={i}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CellListProperties;
